export default __webpack_public_path__ + "static/media/ninos-Banner-Curso-Excel-270x180.5cac9cca.png";